<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span>T<span class="smallcaps">ABLE OF</span> C<span class="smallcaps">ONTENTS</span></span></p>
<p class="toc-entry"><span><a href="#/xhtml/frantmatter01">Cast of Major Characters</a></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter001" title="Link target outside of Sample">1. Napoléon Takes a Bath</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter002" title="Link target outside of Sample">2. What Was the Big Deal About Louisiana, Anyway?</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter003" title="Link target outside of Sample">3. The Deal Is Sealed</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter004" title="Link target outside of Sample">4. What Exactly Did Jefferson Purchase?</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter005" title="Link target outside of Sample">5. The French Claim and Name Louisiana</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter006" title="Link target outside of Sample">6. France Gets Kicked Out and Britain Gets the Boot</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter007" title="Link target outside of Sample">7. Napoléon’s Dream Becomes a Nightmare</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter008" title="Link target outside of Sample">8. The Stars and Stripes Finally Fly Over Louisiana</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter009" title="Link target outside of Sample">9. Lewis and Clark Explore Louisiana</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter010" title="Link target outside of Sample">10. Under My Wings Every Thing Prospers</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/endmatter01" title="Link target outside of Sample">States Formed from the Louisiana Purchase</span></span></p>
<p class="toc-entry1"><span><span href="#/xhtml/endmatter02" title="Link target outside of Sample">Bibliography</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/endmatter03" title="Link target outside of Sample">About the Authors</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?27643367